// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".manageForm[data-v-255735c4] .el-dialog__body{height:calc(90vh - 110px);overflow:auto;padding:15px}.manageForm[data-v-255735c4] .el-dialog__footer{text-align:left;padding:0}.manageForm[data-v-255735c4] .el-input-group__append,.manageForm[data-v-255735c4] .el-input-group__prepend{padding:0 10px}.manageForm .input-with-select[data-v-255735c4] .el-input{width:80px}.contract_form[data-v-255735c4] .el-select{width:100%}", ""]);
// Exports
module.exports = exports;
